export default {
  namespaced: true,
  state: {
    totalCount: 0
  },
  mutations: {
    SET_TOTAL_COUNT(state, count) {
      state.totalCount = count
    }
  },
  actions: {
    // 更新购物车总数
    updateTotalCount({ commit }, count) {
      commit('SET_TOTAL_COUNT', count)
    }
  }
}
